<template>
  <div :class="$style.box">
    <header :class="$style.banner"></header>
    <p>点击下方“<span>一键领取</span>”按钮即可获取您游戏的<span>专属礼包码,</span></p>
    <p>在游戏内使用礼包码可兑换相应奖励。</p>
    <div :class="$style.content">
      <div></div>
    </div>
    <div :class="$style.btn">
      <img :src="`${$cdnUrl}/seckill/main/gift_pick/libao_guize.png`" @click="handleLink" />
      <img
        :src="`${$cdnUrl}/seckill/main/gift_pick/libao_yijianlingqu.png`"
        @click="showPickGiftDialog"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isActStart: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  methods: {
    handleLink() {
      this.$emit('seckillPointReport', 4)
      this.$router.push({ name: "activity.seckillRules" });
    },
    showPickGiftDialog() {
      if (!this.isActStart) {
        this.$toast('当前活动未开始，\n请于4月25日来参加哦！')
        return
      }
      this.$emit('getSeckillGiftList')
    }
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/_variable';
.box {
  display: flex;
  flex-direction: column;
  align-items: center;
  .banner {
    width: 90%;
    height: 25px;
    background-image: url('#{$cdn-url-hm}/seckill/main/gift_pick/libao_biaoti1.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  > p {
    &:nth-child(2) {
      margin-top: 4px;
    }
    font-size: 9px;
    font-weight: 400;
    color: #ece09b;
    line-height: 13px;
    > span {
      color: #fff718;
    }
  }
  .content {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 360px;
    height: 175px;
    margin-top: 6px;
    background-image: url('#{$cdn-url-hm}/seckill/main/gift_pick/libao_banner.png');
    background-size: 100% auto;
    background-repeat: no-repeat;
  }
  .btn {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 65px;
    padding: 0px 40px;
    > img {
      width: 131px;
      height: 49px;
    }
  }
}
</style>
